(function (app) {

    app.provider("agreementsApi",
        [
            function () {
                this.$get = [
                    "portalApiGateway", function (portalApiGateway) {
                        var service = {};
                        /*MasterAdvisorAgreements */
                        //gets
                        service.initMasterAdvisorAgreement = function (workflow) {
                            return portalApiGateway.get("/MasterAdvisorAgreement?workflow=" + workflow);
                        };

                        /*service.getMasterAdvisorAgreementRequired = function () {
                            return portalApiGateway.get("/MasterAdvisorAgreement/IsAdvisorAgreementRequired");
                        };*/

                        service.getMasterAdvisorAgreementRequiredRecord = function () {
                            return portalApiGateway.get("/MasterAdvisorAgreement/AdvisorAgreementRequired");
                        };

                        service.getLoggedInUserMasterAdvisorAgreement = function () {
                            return portalApiGateway.get("/MasterAdvisorAgreement/LoggedInUser");
                        };

                        service.getMasterAdvisorAgreementByEnvelopeIdAsync = function (envelopeId) {
                            return portalApiGateway.get("/MasterAdvisorAgreement/Envelope/" + envelopeId);
                        };

                        service.getMasterAdvisorAgreement = function (agreementId) {
                            return portalApiGateway.get("/MasterAdvisorAgreement/" + agreementId);
                        };

                        //getfiles
                        service.getgetMasterAdvisorAgreementPdfByArcAgentId = function (arcAgentId) {
                            return portalApiGateway.getFile("/MasterAdvisorAgreement/ArcAgent/" + arcAgentId + "/Document/Pdf",
                                { headers: { "Accept": "application/pdf" } });
                        };

                        service.getgetMasterAdvisorAgreementPdf = function (agreementId) {
                            return portalApiGateway.getFile("/MasterAdvisorAgreement/" + agreementId + "/Document/Pdf",
                                { headers: { "Accept": "application/pdf" } });
                        };

                        service.getgetMasterAdvisorAgreementXml = function (agreementId) {
                            return portalApiGateway.getFile("/MasterAdvisorAgreement/" + agreementId + "/Document/Xml",
                                { headers: { "Accept": "application/xml" } });
                        };

                        //posts
                        service.createMasterAdvisorAgreement = function (envelopeData) {
                            return portalApiGateway.post("/MasterAdvisorAgreement/", envelopeData);
                        };

                        //deletes
                        service.removeMasterAdvisorAgreement = function (agreementId) {
                            return portalApiGateway.delete("/MasterAdvisorAgreement/" + agreementId);
                        };


                        /* SurveyAgreements */
                        //gets
                        
                        service.getSurveyAgreementRenewalDocusignLink = function (surveyId, surveyRenewalId) {
                            return portalApiGateway.get("/SurveyAgreement?surveyId=" + surveyId + "&surveyRenewalId=" + surveyRenewalId);
                        };

                        return service;
                    }
                ];
            }
        ]);
})(window.app);